module.exports = __webpack_public_path__ + "static/media/19.e134d7fa.jpg";